import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Tv } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// One-tap switch: TV shows tokens (normal) or promotions only
export const TVModeToggle = ({ token }) => {
  const [promoOnly, setPromoOnly] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/public/tv-settings`).then(({ data }) => setPromoOnly(data.promo_only === true)).catch(() => {});
  }, []);

  const toggle = async () => {
    setBusy(true);
    try {
      const { data } = await axios.put(`${API}/tv-settings/promo-only`, { enabled: !promoOnly }, { headers: { Authorization: `Bearer ${token}` } });
      setPromoOnly(data.promo_only);
      toast.success(data.promo_only ? 'TV: promotions only (tokens hidden)' : 'TV: token display ON');
    } catch (e) {
      toast.error('Could not change TV mode');
    } finally { setBusy(false); }
  };

  return (
    <Button
      onClick={toggle}
      disabled={busy}
      variant="ghost"
      data-testid="tv-token-toggle"
      title={promoOnly ? 'TV is showing promotions only. Tap to show tokens again.' : 'Tap to hide tokens and show only promotions on TV'}
      className={`text-xs md:text-sm ${promoOnly ? 'bg-orange-100 text-orange-800 hover:bg-orange-200 hover:text-orange-900' : 'hover:bg-slate-100 text-slate-700 hover:text-slate-900'}`}
    >
      <Tv className="mr-1 md:mr-2 h-4 w-4" />
      <span className="hidden md:inline">{promoOnly ? 'Tokens OFF' : 'Tokens ON'}</span>
    </Button>
  );
};
